"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hookFactory = void 0;

var helpers_1 = require("./helpers");

var useHook = function useHook(dataName) {
  var saleor = helpers_1.useSaleorClient();

  var getHookData = function getHookData() {
    return saleor[dataName];
  };

  return getHookData();
};

exports.hookFactory = function (query) {
  return function () {
    return useHook(query);
  };
};